import React, { useRef, useState } from 'react'
import Navbar from '../../components/Navbar'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import { useTranslation } from 'react-i18next'
import Footer from '../../components/Footer'
import { PrimaryButton } from '../../components/StyledButtons'
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu'
import filter_color from "../../assets/images/design/colorFilter.svg"
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const General = () => {
    const { t } = useTranslation()

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    
    const modalDiscussionRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='general bg-primary'>
            <div className='color-filter-right' style={{ top: "30%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <Navbar />
            <div className='container-fluid general-header pb-100'>

                <div className='container'>
                    <div className='col-sm-12 pt-150'>
                        <div className='font-weight-bold text-center font-64 general-header-title'>{t('general.header')}
                        </div>
                        <div className='col-lg-6 col-lg-offset-3 col-sm-10 col-sm-offset-1'>
                            <div className='underline-orange'></div>
                        </div>
                    </div>
                    <div className='col-sm-12 flex justify-center pt-50 px-0'>
                        <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.general')} linkToPrevPage="/industries" />
                    </div>
                </div>
            </div>
            <div className='general-content container'>
                <div className='row'>
                    <div className='col-lg-w-400'>
                        <IndustriesStickyMenu generalActive={true} />
                    </div>
                    <div className='col-lg-w--400 general-content_info'>
                        <p className='font-48 font-weight-medium text-white'>{t('general.title')}</p>
                        <p className='text-white pt-20'>{t('general.content-1')}</p>
                        <p className='text-white pt-20'>{t('general.content-2')}</p>
                        <div className='pt-30'>
                            <PrimaryButton 
                            onClick={() => setModalDiscussionOpen(true)}
                            >{t('button.schedule-discussion')}</PrimaryButton>
                        </div>
                    </div>
                </div>
                <IndustriesImageContainer />
            </div>
            <Footer />
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
            
        </div>
    )
}

export default General